import {
    MaybeRef,
    onMounted,
    onUnmounted,
    unref,
    watch,
} from "vue";

export function useEventListener<TEvent extends Event>(
    target: EventTarget,
    name: string,
    cb: (event: TEvent) => void,
    options?: AddEventListenerOptions,
) {
    const listener = cb as EventListener;

    onMounted(() => target.addEventListener(name, listener, options));
    onUnmounted(() => target.removeEventListener(name, listener, options));
}

export function useEventListenerAutoSwitch<TEvent extends Event>(
    targetRef: MaybeRef<EventTarget | null | undefined | void>,
    name: string,
    cb: (event: TEvent) => void,
    options?: AddEventListenerOptions,
) {
    const listener = cb as EventListener;

    watch(() => unref(targetRef), (newValue, oldValue) => {
        if (newValue)
            newValue.addEventListener(name, listener, options);

        if (oldValue)
            oldValue.removeEventListener(name, listener, options);
    });

    onMounted(() => {
        unref(targetRef)?.addEventListener(name, listener, options);
    });

    onUnmounted(() => {
        unref(targetRef)?.removeEventListener(name, listener, options);
    });
}
